var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-layout sample-profile type-report"},[_c('sample-navbar'),_c('div',{staticClass:"wrapper report",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('notifications'),_c('app-side-bar',{attrs:{"mini":true,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('mobile-menu'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: 'About the Data',
            icon: 'help',
            path: 'market-rep-about-data',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Competitive Summary',
            icon: 'star_half',
            path: 'competitive-summary',
          }}}),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'Competitors' }),expression:"{ name: 'Competitors' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Competitors',
              icon: 'location_on',
              path: 'market-rep-competitors',
            }}})],1),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'market' }),expression:"{ name: 'market' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Market',
              icon: 'trending_up',
              path: 'market-rep-market',
            }}})],1),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'market-rep-annual-sales' }),expression:"{ name: 'market-rep-annual-sales' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Annual Sales',
              icon: 'area_chart',
              path: 'market-rep-annual-sales',
            }}})],1),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Penetration',
            icon: 'business',
            path: 'market-rep-penetration',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Employment',
            icon: 'account_box',
            path: 'market-rep-employment',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Sales/Emp Classes',
            icon: 'price_change',
            path: 'market-rep-sales',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Productivity',
            icon: 'work',
            path: 'market-rep-productivity',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Startups',
            icon: 'settings_input_antenna',
            path: 'market-rep-startups',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Cessation',
            icon: 'area_chart',
            path: 'market-rep-cessation',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Ownership',
            icon: 'location_city',
            path: 'market-rep-ownership',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Demographics',
            icon: 'home',
            path: 'market-rep-demographics',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Manage Inputs',
            icon: 'settings',
            path: 'manage-inputs',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Customize Report',
            icon: 'tune',
            path: 'customize-report',
          }}})],1)],2),_c('div',{staticClass:"main-panel"},[_c('div',{class:{ content: !_vm.$route.meta.hideContent }},[(!_vm.isAboutRoute)?_c('div',{staticClass:"content"},[_c('PulseLoader',{class:{ hide: !_vm.loading },attrs:{"loading":_vm.loading,"quote":"Action is the foundational key to all success","author":"Pablo Picasso","profession":"Spanish Painter","img":"picasso.jpg"}})],1):_vm._e(),_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('div',{staticClass:"row"},[(!_vm.loading || _vm.isAboutRoute)?_c('router-view',{attrs:{"headerData":_vm.headerData}}):_vm._e()],1)])],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }